import { render, staticRenderFns } from "./OppRequest.vue?vue&type=template&id=c5740d10&"
import script from "./OppRequest.vue?vue&type=script&lang=js&"
export * from "./OppRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports